<template>
    <div>
        <div class="row">
            <div class="col">
                <h5>Please select the required rooms for your party</h5>
                <p>
                    The types of rooms are required to give the most accurate price.  Hotel rooms are subject to availability.
                    Rooming arrangements will be confirmed with you before you travel.
                </p>
                <hr>
            </div>
        </div>
        <div class="row">
            <app-hotel v-for="hotel in roomTypes" 
                :ref="hotel.productId" 
                :key="hotel.productId" 
                :hotel="hotel" 
                :totalPassengers="totalPassengers"
                @onValidate="validate"></app-hotel>
        </div>

        <div v-if="showWarningMessage" class="row justify-content-around mt-4">
            <div class="alert alert-danger">
                You have not selected enough rooms for all passengers.  Please check that all hotels above have a <font-awesome-icon icon="check" /> against them and then continue.
            </div>
        </div>

        <div class="row my-4 justify-content-end">
            <button class="btn btn-info mx-1" @click="prevStep">Previous</button>
            <button class="btn btn-success mx-1" @click="nextStep">Next</button>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import appHotel from '../rooming/Hotel.vue';

export default {
    data() { 
        return { 
            showWarningMessage: false,
        }
    },
    computed: { 
        ...mapState({ 
            noOfInfants: state => state.passengers.noOfInfants,
        }),
        ...mapGetters({
            roomTypes: 'getHotelRoomTypes',
            totalPassengers: 'getPassengersToRoom',
            everyoneHasARoom: 'getEveryoneHasARoom'
        }),
    },
    methods: { 
        ...mapActions([ 'prevStep' ]),
        validate() {
            // loop through all hotel refs and check they are not invalid
            for (let i = 0; i < this.roomTypes.length; i++) {
                let hotel = this.roomTypes[i];
                let hotelRef = this.$refs[hotel.productId][0];

                if (!hotelRef.isValid) {
                    this.showWarningMessage = true;
                    return;
                }
            }

            this.showWarningMessage = false;
        },
        nextStep() {
            if (!this.showWarningMessage && this.everyoneHasARoom) {
                this.$store.dispatch('nextStep');
            } else {
                this.showWarningMessage = true;
            }
        }
    },
    components: {
        appHotel
    }
}
</script>